import {Stack, Typography} from '@mui/material'
import {NotificationInterface} from '@/types/types'
import React, {useEffect, useRef} from 'react'
import formatDate from '@/helpers/FormatDateFromApi'

const Index = ({
  nextPaging,
  notifications,
  scrollRef,
  readNotification,
  setPage,
}: {
  notifications: NotificationInterface[]
  scrollRef: any
  nextPaging: string | null
  readNotification: (v: {ids: string[]}) => void
  setPage: any
}) => {
  const notificationsRef = useRef<HTMLDivElement | null>(null)

  const handleScroll = () => {
    const {scrollTop, scrollHeight, clientHeight} =
      notificationsRef.current || {}
    if (
      scrollTop !== undefined &&
      clientHeight !== undefined &&
      scrollHeight !== undefined
    ) {
      if (scrollTop + clientHeight >= scrollHeight - 2) {
        if (scrollRef.current) return
        scrollRef.current = true
        setPage((page: any) => page + 1)
      }
    }
  }

  useEffect(() => {
    const container = notificationsRef.current

    if (container) {
      if (notifications.length > 0) {
        const scrollPosition =
          ((notifications.length - 10) / notifications.length) *
          container.scrollHeight
        container.scrollTop = scrollPosition
      }
    }

    if (!nextPaging) return

    if (container) {
      container.addEventListener('scroll', handleScroll)
    }
    return () => {
      if (container) {
        container.removeEventListener('scroll', handleScroll)
      }
    }
  }, [notifications])

  return (
    <Stack className="events-block" width="100%" ref={notificationsRef}>
      {notifications.map((notification: NotificationInterface, index) => {
        const date = formatDate(notification.created_at)
        return (
          <Stack
            className="pointer"
            bgcolor={notification.is_read ? '' : '#FFD7AE66'}
            justifyContent="space-between"
            padding="10px 20px"
            direction="row"
            key={'notification' + index}
            onClick={() => {
              if (!notification.is_read) {
                readNotification({ids: [notification.id]})
              }
            }}>
            <Stack gap="10px" direction="row" alignItems="center">
              <img
                alt=""
                src={`${window.location.origin}/svgs/${notification.data.img}`}
                width="40px"
                height="40px"
              />
              <Typography variant="body2">
                {notification.data.description}
              </Typography>
            </Stack>
            <Stack>
              <Typography variant="body2" textAlign="right">
                {`${date.hours}:${date.minutes}`}
              </Typography>
              <Typography variant="body2" style={{textWrap: 'nowrap'}}>
                {`${date.year}-${date.month}-${date.day}`}
              </Typography>
            </Stack>
          </Stack>
        )
      })}
    </Stack>
  )
}

export default Index
